module.exports = __webpack_public_path__ + "img/coblow.7ea65ea6.jpg";